import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Layout from './components/Layout';
import Home from './pages/Home';
import Project from './pages/Project';
import Resource from './pages/Resource';
import JobInformationPage from './pages/JobInformation';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import JobDetails from './pages/JobDetails';
import SurveyCenter from './pages/SurveyCenter';
import FeedbackPage from './components/FeedbackPage.tsx'; // ✅ import feedback page
import './index.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const handleRouteChange = () => {
      console.log('Route changed:', window.location.pathname);
    };

    window.addEventListener('popstate', handleRouteChange);
    return () => window.removeEventListener('popstate', handleRouteChange);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <Home />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/project" element={
            <ProtectedRoute>
              <Layout>
                <Project />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/resource" element={
            <ProtectedRoute>
              <Layout>
                <Resource />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/survey-center/:jobId/:runId" element={
            <ProtectedRoute>
              <Layout>
                <SurveyCenter />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/jobinformations" element={
            <ProtectedRoute>
              <Layout>
                <JobInformationPage />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/jobdetails/:jobId" element={
            <ProtectedRoute>
              <Layout>
                <JobDetails />
              </Layout>
            </ProtectedRoute>
          } />

          {/* ✅ Feedback page */}
          <Route path="/feedback" element={
            <ProtectedRoute>
              <Layout>
                <FeedbackPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Redirect unknown paths to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
